<script>
  import { _ } from "../../services/i18n";
</script>

<section  class="section-composition">
  <table class="table-composition">
    <tr>
      <td class="box-composition" id="e-box">
        <a href="#/tuto?/config/vendors">
          <h5>{$_("tutorial_config_vendors")}</h5>
          <div class="info-composition">
            <p>Saber más</p>
            <img id="user-composition" src="/icons/arrow-left-white.svg" alt="close" />
          </div>
          <img id="element-composition" src="/icons/silla.png" alt="close" />
        </a>
      </td>
      <td class="box-composition" id="m-box">
        <a href="#/tuto?/config/tarifs">
          <h5>{$_("tutorial_config_tarif")}</h5>
          <div class="info-composition">
            <p>Saber más</p>
            <img id="user-composition" src="/icons/arrow-left-white.svg" alt="close" />
          </div>
          <img id="element-composition" src="/icons/metraje.png" alt="close" />
        </a>
      </td>
    </tr>
  </table>
</section>
